import { CKEditor } from 'ckeditor4-react';

interface Props {
    data: string
    onChange: (event: any) => void;
}

const Editor = ({ data, onChange }: Props) => {


    return (
        <CKEditor
            debug={true}
            config={{
                removePlugins: "notification", // Removes the notification plugin
                toolbar: [
                    // Define a single group with bullet and numbered list buttons
                    { name: "list", items: ["BulletedList", "NumberedList"] },
                ],
            }}
            initData={data}
            onChange={(event) => {
                onChange(event.editor.getData())
            }}
        />
    )
}

export default Editor;